var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',_vm._l((_vm.images),function(image,index){return _c('b-col',{key:index,attrs:{"cols":"6","md":"3"}},[_c('b-img',{attrs:{"fluid":"","src":require('@/assets/images/icons/' + image.svg)}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }